import { ResourcesApiUrls } from "./api-urls";
import axios from "axios";
import globalVariables from "../global-variables";

export const GetResourcesList = (p_request_object, p_success_function, navigate) => {
	
    //Get resource List
	axios.post(globalVariables.variables.strApiUrl + ResourcesApiUrls.get_resources_api, p_request_object)
	.then((response_list) => {
		setTimeout(() => {
			if(response_list.data === 'error')
			{
				navigate('/error-page')
			}
			else
			{
				// pass the result in the success function of the respective page
				p_success_function(response_list.data[0]);
			}
		}, 100);
	});

};